import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "LI_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#LI_svg__a)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v24h32V0H0z",
      fill: "#E31D1C"
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "LI_svg__b",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 0v24h32V0H0z",
        fill: "#fff"
      }
    )
  ), /* @__PURE__ */ e.createElement("g", { mask: "url(#LI_svg__b)" }, /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 0v12h32V0H0z",
      fill: "#2E42A5"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.797 11.053s1.207.751 4.003.751c2.796 0 4.28-.751 4.28-.751s-2.193-1.275-4.153-1.275c-1.961 0-4.13 1.275-4.13 1.275z",
      fill: "#000"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M4.87 6.742l-.215.126.072.124h8.652l.055-.174-.238-.076c.238.076.238.076.239.075h0v-.002l.002-.006.006-.02a3.916 3.916 0 00.081-.328 5.18 5.18 0 00.109-.845c.027-.648-.08-1.493-.71-2.04-.64-.558-1.454-.47-2.156-.296-.239.06-.482.135-.71.205-.108.034-.212.066-.311.095-.321.094-.59.156-.805.156-.214 0-.45-.057-.728-.145-.085-.026-.174-.056-.267-.087-.2-.067-.416-.139-.633-.196-.659-.173-1.42-.239-2.262.239-.44.248-.69.595-.809.974-.116.372-.102.761-.04 1.102A4.11 4.11 0 004.6 6.764l.04.075.01.02.004.006.001.002h0l.217-.125z",
      fill: "#FFD83D",
      stroke: "#000",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.885 6.906l.117.221-.116-.221h0l.002-.001.005-.003.017-.009.064-.03c.055-.025.137-.06.244-.103.214-.084.532-.195.954-.305.846-.22 2.11-.437 3.802-.437 1.693 0 2.957.217 3.803.437.422.11.74.221.954.305a4.684 4.684 0 01.307.133l.018.009.005.003h.002l-.116.222.116-.221.195.103-.077.206-1.185 3.168-.082.22-9.029-3.697zm0 0l-.193.102.075.205L4.92 10.38l.08.221.226-.067-1.34-3.629zm8.803 3.628h0l-7.462.001h.001l.004-.001.015-.005.062-.017a16.383 16.383 0 011.092-.255c.71-.14 1.651-.28 2.593-.28s1.867.14 2.558.28a15.064 15.064 0 011.118.272l.015.004.004.001h0zM8.873 4.265c.56 0 .923-.547.923-1.095 0-.549-.363-1.096-.923-1.096s-.922.547-.922 1.096c0 .548.363 1.095.922 1.095z",
      fill: "#FFD83D",
      stroke: "#000",
      strokeWidth: 0.5
    }
  ), /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "LI_svg__c",
      maskUnits: "userSpaceOnUse",
      x: 7.117,
      y: -1,
      width: 4,
      height: 5,
      fill: "#000"
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M7.117-1h4v5h-4z" }),
    /* @__PURE__ */ e.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M9.125 0h-.504l.065.923-.569-.077v.634l.578-.08-.074 1.453h.504l-.074-1.455.579.082V.846L9.06.927 9.125 0z"
      }
    )
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M9.125 0h-.504l.065.923-.569-.077v.634l.578-.08-.074 1.453h.504l-.074-1.455.579.082V.846L9.06.927 9.125 0z",
      fill: "#FFD83D"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M8.621 0v-.5h-.536l.037.535.5-.035zm.504 0l.5.035L9.66-.5h-.536V0zm-.439.923l-.067.496.609.082-.043-.613-.499.035zM8.117.846L8.185.35 7.617.273v.573h.5zm0 .634h-.5v.573l.568-.078-.068-.495zm.578-.08l.5.025.03-.603-.599.083.069.495zM8.62 2.853l-.5-.025-.026.525h.526v-.5zm.504 0v.5h.527l-.027-.526-.5.026zm-.074-1.455l.07-.495-.6-.086.03.606.5-.025zm.579.082l-.07.495.57.08V1.48h-.5zm0-.634h.5V.269L9.559.35l.07.495zM9.06.927L8.562.893l-.042.617.612-.088-.07-.495zM8.621.5h.504v-1h-.504v1zm.564.388L9.12-.035l-.998.07.065.923.998-.07zm-1.135.453l.569.078.134-.991L8.185.35l-.135.991zm.567.139V.846h-1v.634h1zm.01-.575l-.578.08.136.99.578-.08-.137-.99zm.493 1.973l.074-1.453-.999-.05-.073 1.453.998.05zm.005-.525h-.504v1h.504v-1zm-.574-.93l.075 1.455.999-.05-.075-1.456-.999.051zM9.7.985L9.12.903l-.14.99.58.082.14-.99zm-.57-.14v.635h1V.846h-1zm.002.577l.569-.081-.142-.99-.569.081.142.99zM8.626-.035l-.064.928.998.069.064-.927-.998-.07z",
      fill: "#000",
      mask: "url(#LI_svg__c)"
    }
  )))
), h = t;
export {
  h as default
};
